export default {"src":"/_next/static/image/public/images/ic_attach_grey.4126af379ce3f07707c6ce202846b855.svg","height":16,"width":15};